export * from './lib/components/pdf-viewer/pdf-viewer.component';
